import BadgeSelect from './BadgeSelect'

export default BadgeSelect
